<template>
  <div>
    <div v-if="dataReady" id="dataReady" />
    <div class="headerEvaluationReport">
      <div class="headerEvaluationReportIcon">
        <div class="logo">
        <div class="d-flex justify-content-center">
          <img
              :src="
                '/static/images/unpd/unpd_logo_white_' + lang + '.svg'
              "
              height="200"
              style="margin: 0px -45px 0 0"
          />
          <img
            :src="'./static/images/GES_Logo-White.svg'"
            height="260"
            style="margin-top: -30px;"
          />
        </div>
      </div>
        </div>
      </div>
      <div class="headerEvaluationReportGreen">
        <div class="info-company-evaluation">
          <h4
            v-if="
              (getBusiness &&
                getBusiness.selfAssessment_general_business_companyName) ||
              bussinessLoaded
            "
            id="companyName"
            class="boldH4"
          >
            {{ getBusiness.selfAssessment_general_business_companyName }}
          </h4>
          <h3>
            {{ $t("label_evaluation_report_title") }}
          </h3>
          <h3>
            {{
              evaluationData.evaluation_administrator_evaluations_evaluationName
            }}
          </h3>
          <h3>{{ $t("label_evaluation_report_date") }} {{ today }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import { Tree } from "../../../../utils/vue-tree-list";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";
import moment from "moment";

export default {
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["getBusiness"]),
  },
  name: "EvaluationModelsRequirements",
  components: {},
  data: function () {
    return {
      today: "",
      data: new Tree([]),
      evaluationId: this.$route.params.evaluationId,
      evaluationData: { evaluation: {} },
      status: "success",
      dataReady: false,
      bussinessLoaded: false,
    };
  },
  async created() {
    this.today = moment().format("YYYY-MM-DD");

    if (this.$route.params.lang) {
      this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    var business = {
      id: this.$route.params.businessId,
    };
    this.$store.commit("authSuccess", auth);
    this.$store.commit("setBusiness", business);
    this.$store.commit("setCurrentBusiness", business);
    this.$store
      .dispatch("BUSINESS_GET")
      .then(() => {})
      .catch((err) => {
        console.log(err);
        this.bussinessLoaded = true;
      });
    await axiosCall({ url: "UserAccounts/get", method: "GET" }).then(
      (account) => {
        this.account = account.data;
      }
    );
    await axiosCall({
      url: "Evaluations/" + this.evaluationId,
      method: "GET",
    }).then((response) => {
      this.evaluationData = response.data;
      this.dataReady = true;
    });
  },
};
</script >

<style lang="scss" scoped>
@import "../../../../assets/css/variables";
h4 {
  font-size: 2rem;
  text-transform: uppercase;

}
h3{
  font-size: 2rem;
  color: $primary-color !important;
  text-align: center;
  font-weight: normal !important;
  font-family: $font-subtitle;
}
.cardContainer {
  border: 1px solid #000000;
  width: 100%;
  padding: 30px 40px;
  margin-bottom: 15px;
}
.cardContainer  h3 {
  text-align: center;
  width: 100%;
}
h2 {
  color: black;
  margin: 1em 0;
}
.label {
  font-weight: bold;
  font-size: 14px;
}
.headerEvaluationReportIcon {
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 900px;
  background: $primary-color;
  .logo{
    margin-top: 20px;
  }
}
.headerEvaluationReportGreen {
  left: 0px;
  width: 900px;
  height: 900px;
  background: #f5fafd 0% 0% no-repeat padding-box;
  opacity: 1;
  position: relative;
}
.evaluationReportContent {
  margin-left: 1cm;
  margin-right: 1cm;
}

.info-company-evaluation {
  color: $primary-color !important;
  width: 486px;
  margin: 279px auto;
}
.unpd_logo_evaluation {
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
}
#companyName{
  font-size: 45px !important;
  color: $primary-color !important;
  font-weight: bold !important;
  margin-bottom: 50px;
  margin-left: 0px;
}
h4{
  text-align: center;
}
</style >
